import { Box } from '@mui/material';
import FormError from 'components/form-error/form-error.component';
import { getRecacheError } from '../../forms/spreedly-cvv-recache-form/spreedly-cvv-recache-form.utils';
import { useSpreedlyGlobalErrors } from '../../forms/spreedly-global-errors/spreedly-global-errors.hooks';

const SpreedlyCVVGlobalErrors = () => {
  const formErrors = useSpreedlyGlobalErrors();

  if (formErrors.length === 0) return null;

  return (
    <Box mt={1}>
      <FormError
        aria-live="assertive"
        errorMessage={getRecacheError(formErrors)}
      />
    </Box>
  );
};

export default SpreedlyCVVGlobalErrors;
